import React, { useEffect, useState } from "react";
import "./Product_info.css";
import StarRatings from "react-star-ratings";
import Favourite_icon from "../../common-components/favourite-icon/Favourite_icon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import Want_buy_modal from "../../common-components/common-modals/want-buy-modal/Want_buy_modal";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Category, encodeId } from "../../../utils/common";
import Lense_prescription_modal from "../../common-components/common-modals/want-buy-modal/Lense_prescription_modal";
import { getAllCart, postCart } from "../../../features/cart/cartSlice";
import Cookies from "js-cookie";

const Product_info = ({
  avgrating,
  product_id,
  product,
  variant,
  setVariant,
  ...props
}) => {
  const [wantbuy, setWantbuy] = useState(false);
  const handleShare = () => {
    const url =
      `${window.location.origin}/product-descrption/${encodeId(product_id)}` ||
      window.location.href;
    const title = product?.name || document.title;

    if (navigator.share) {
      // Native share (mobile + some desktop browsers)
      navigator
        .share({
          title: title,
          text: `Check out this product: ${title}`,
          url: url,
        })
        .catch((err) => console.error("Share cancelled", err));
    } else {
      // Fallback: Open social share links (example: WhatsApp)
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
        `Check out this product: ${title} - ${url}`,
      )}`;
      window.open(whatsappUrl, "_blank");
    }
  };
  const navigate = useNavigate();
  const location = useLocation();
  const is_signin = useSelector((state) => state.auth.is_signin);
  const handleBuyNow = () => {
    // navigate to login page
    // Cookies.set(
    //   "current_url",
    //   location.pathname
    // );
    navigate("/login-product-detail");
  };
  const [lensemodal, setLensemodal] = useState(false);
  const dispatch = useDispatch();
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const addToCart = async () => {
    try {
      const data = {
        product_id: product?.id,
        variant_id: variant?.id,
        quantity: 1,
      };
      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(getAllCart(isSignIn));
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return (
    <>
      <section className="productinfodiv">
        <div className="row">
          <div className="col-md-8">
            <div className="leftsec">
              <p className="brandname">{product?.p_category?.name} </p>
              <p className="prod-name">
                {Number(product?.p_category_id) ===
                  Number(Category.ContactLens) ||
                  Number(product?.p_category_id) === Number(Category.Lenses) ||
                  Number(product?.p_category_id) === Number(Category.Accessories)
                  ? product?.name
                  : `${product?.Brand?.name}  ${product?.model_no}`}{" "}
              </p>
              <p className="prise">
                <span className="mainprise">₹{product?.price}-</span>
                <span className="oldprise">₹{product?.mrp}</span>
                <span className="discount">
                  {Math.round(
                    ((product.mrp - product.price) / product.mrp) * 100,
                  )}
                  % off
                </span>
                {/* <span className="ratings">
                  <StarRatings
                    rating={Number(avgrating?.average_rating || 0)}
                    starDimension="17px"
                    starSpacing="1px"
                    starRatedColor="#FFC107"
                  />
                  ({avgrating?.total_counts} review)
                </span> */}
                <span className="whtsap" onClick={handleShare}>
                  <img
                    className="icon"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/icons/share.png"
                    }
                  />
                </span>
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="rightsec">
              <Favourite_icon id={product?.id} />

              <p
                className="oneleftp"
                style={{
                  color: product?.available_stock <= 0 ? "red" : "inherit",
                }}
              >
                {/* {product?.available_stock > 0
                  ? `Only ${product.available_stock} Left!`
                  : "Out of Stock"} */}
              </p>

              <div className="btnvariantflex">
                <div className="colorvarientdiv">
                  {product?.Colour?.first_color && (
                    <div
                      className="color"
                      style={{ backgroundColor: product?.Colour?.first_color }}
                    ></div>
                  )}
                </div>

                <div className="bunowdiv">
                  {is_signin ? (
                    <button
                      type="button"
                      onClick={() => {
                        if (
                          product?.p_category_id === 3 ||
                          product?.p_category_id === 1
                        ) {
                          setLensemodal(true);
                        } else if (product?.p_category_id === 4) {
                          addToCart();
                        } else {
                          setWantbuy(true);
                        }
                      }}
                      className="buynowbtn"
                      // disabled={product?.available_stock <= 0}
                      // style={{
                      //   opacity: product?.available_stock <= 0 ? 0.5 : 1,
                      //   cursor:
                      //     product?.available_stock <= 0
                      //       ? "not-allowed"
                      //       : "pointer",
                      // }}

                      style={{
                        opacity: 1,
                        cursor: "pointer",
                      }}
                    >
                      <FontAwesomeIcon
                        className="carticon"
                        icon={faCartShopping}
                      />
                      Buy Now
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={handleBuyNow}
                      className="buynowbtn"
                    // disabled={product?.available_stock <= 0}
                    // style={{
                    //   opacity: product?.available_stock <= 0 ? 0.5 : 1,
                    //   cursor:
                    //     product?.available_stock <= 0 ? "not-allowed" : "pointer",
                    // }}
                    >
                      <FontAwesomeIcon
                        className="carticon"
                        icon={faCartShopping}
                      />
                      Buy Now
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="Product_details_sec">
          <div className="row">
            <div className="col-lg-12">
              <div className="contsec">
                <h6 className="prodtitle">Product Details</h6>
                {product?.Frame_Type?.name && (
                  <p className="discp">
                    <span>Frame Type - </span>
                    {product?.Frame_Type?.name}
                  </p>
                )}

                {product?.Brand?.name && (
                  <p className="discp">
                    <span>Brand - </span>
                    {product?.Brand?.name}
                  </p>
                )}
                {product?.Gender?.name && (
                  <p className="discp">
                    <span>Gender - </span>
                    {product?.Gender?.name}
                  </p>
                )}
                {product?.Shape?.name && (
                  <p className="discp">
                    <span>Shape - </span>
                    {product?.Shape?.name}
                  </p>
                )}
                {product?.Material?.name && (
                  <p className="discp">
                    <span>Material - </span>
                    {product?.Material?.name}
                  </p>
                )}
                {product?.Colour?.name && (
                  <p className="discp">
                    <span>Frame Colour - </span>
                    {product?.Colour?.name}
                  </p>
                )}
                {product?.lens_color?.name && (
                  <p className="discp">
                    <span>Lens Colour - </span>
                    {product?.lens_color?.name}
                  </p>
                )}

                {product?.base_curve && (
                  <p className="discp">
                    <span>Base Curve - </span>
                    {product?.base_curve}
                  </p>
                )}
                {product?.water_content && (
                  <p className="discp">
                    <span>Water Content - </span>
                    {product?.water_content}
                  </p>
                )}
                {product?.modality && (
                  <p className="discp">
                    <span>Modality - </span>
                    {product?.modality}
                  </p>
                )}
                {product?.diameter && (
                  <p className="discp">
                    <span>Diameter - </span>
                    {product?.diameter}
                  </p>
                )}
                {product?.dk_t && (
                  <p className="discp">
                    <span>DK/T -</span>
                    {product?.dk_t}
                  </p>
                )}
                {product?.bo_code && (
                  <p className="discp">
                    <span>BO Code - </span>
                    {product?.bo_code}
                  </p>
                )}
                {product?.size && (
                  <p className="discp">
                    <span> {product?.p_category_id === Category.ContactLens ? "Pack Size" : "Size"} - </span>
                    {product?.size}
                  </p>
                )}

                {product?.total_measurements && (
                  <p className="discp">
                    <span>Total Measurements - </span>
                    {product?.total_measurements}
                  </p>
                )}
                {product?.description && (
                  <p className="discp">
                    <span>Description - </span>
                    {product?.description}
                  </p>
                )}

                {/* <p className='discp'><span>Model No-</span>{variant?.model_no}</p>
                                    <p className='discp'><span>Barcode-</span>{variant?.barcode}</p> */}
              </div>
            </div>
          </div>
        </section>

        <Want_buy_modal
          product={product}
          variant={variant}
          product_id={product_id}
          show={wantbuy}
          onHide={() => setWantbuy(false)}
        />

        <Lense_prescription_modal
          product={product}
          variant={variant}
          product_id={product_id}
          // lensTypeId={lensTypeId}
          // addOnId={addOnId}
          // lenseId={lenseId}
          // lensId={lensId}
          // lensOptionId={lensOptionId}
          show={lensemodal}
          onHide={() => setLensemodal(false)}
        />
      </section>
    </>
  );
};

export default Product_info;
